'use strict';

exports.__esModule = true;
exports.generateWixCodeImageUri = generateWixCodeImageUri;
exports.generateWixCodeDocumentUri = generateWixCodeDocumentUri;
exports.generateWixCodeVideoUri = generateWixCodeVideoUri;
exports.generateWixCodeAudioUri = generateWixCodeAudioUri;
exports.extractImageRelativeUriFromWixUri = extractImageRelativeUriFromWixUri;
exports.extractImageDataFromWixUri = extractImageDataFromWixUri;

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IMAGE_URI = 'image://';
var DOC_URI = 'wix:document://';
var VIDEO_URI = 'wix:video://';
var AUDIO_URI = 'wix:audio://';
var VERSION = 'v1';
var wixCodeImgUriTemplate = _lodash2.default.template(IMAGE_URI + VERSION + '/${uri}/${width}_${height}/${title}');
var wixCodeDocUriTemplate = _lodash2.default.template(DOC_URI + VERSION + '/${uri}/${filename}');
var wixCodeVideoUriTemplate = _lodash2.default.template(VIDEO_URI + VERSION + '/${uri}/${filename}#posterUri=${posterUri}&posterWidth=${posterWidth}&posterHeight=${posterHeight}');
var wixCodeAudioUriTemplate = _lodash2.default.template(AUDIO_URI + VERSION + '/${uri}/${filename}');
var MEDIA_SRC_REGEX = /^image:\/\/(.*)\/(.*)\/(.*)_(.*)\/(.*)/;

function generateWixCodeImageUri(imageData) {
  return wixCodeImgUriTemplate(imageData);
}

function generateWixCodeDocumentUri(documentData) {
  return wixCodeDocUriTemplate(documentData);
}

function generateWixCodeVideoUri(documentData) {
  return wixCodeVideoUriTemplate(documentData);
}

function generateWixCodeAudioUri(documentData) {
  return wixCodeAudioUriTemplate(documentData);
}

function removeEmptyValues(res, v, k) {
  if (v) {
    res[k] = v;
  }
  return res;
}

function extractImageRelativeUriFromWixUri(wixCodeImageUri) {
  if (MEDIA_SRC_REGEX.test(wixCodeImageUri)) {
    var _ref = wixCodeImageUri.match(MEDIA_SRC_REGEX) || [0, 0, wixCodeImageUri],
        baseSrc = _ref[2];

    return baseSrc;
  }

  return wixCodeImageUri;
}

function extractImageDataFromWixUri(wixCodeImageUri) {
  if (MEDIA_SRC_REGEX.test(wixCodeImageUri)) {
    var _ref2 = wixCodeImageUri.match(MEDIA_SRC_REGEX) || [0, 0, wixCodeImageUri],
        uri = _ref2[2],
        width = _ref2[3],
        height = _ref2[4],
        title = _ref2[5];

    return _lodash2.default.reduce({ uri: uri, width: width, height: height, title: title }, removeEmptyValues, {});
  }

  return { uri: wixCodeImageUri };
}
//# sourceMappingURL=uriUtils.js.map